import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Container, GetStartedBtn } from './sign-up.css';

class SignUp extends Component {
  static propTypes = {
    queryParams: PropTypes.object,
  };

  render() {
    const { queryParams = {} } = this.props;
    return (
      <Container>
        {queryParams && queryParams.v === '2' ? (
          <div
            style={{
              lineHeight: '1.3',
              fontSize: '1.1em',
              paddingTop: '10px',
              color: '#999',
              textAlign: 'center',
            }}
          >
            <span style={{ color: '#93b7c8' }}>Sold.com</span> matched 4,500
            home owners with the best approach for selling their home in the
            past 30 days!
          </div>
        ) : (
          <Fragment>
            <GetStartedBtn
              to="survey"
              spy={true}
              smooth={true}
              offset={0}
              duration={500}
              isDynamic={true}
              href="#"
            >
              Get Started
            </GetStartedBtn>
            <p>Get your free evaluation in a few clicks</p>
          </Fragment>
        )}
      </Container>
    );
  }
}

export default SignUp;
